import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  constructor(private http: HttpClient) { }

  searchPromotion(criteria: any) {
    return firstValueFrom(this.http.post<PromotionSearchResult>('/api/promotion/search', criteria));
  }

  getPromotion(id: string) {
    return firstValueFrom(this.http.get<any>(`/api/promotion/get/${id}`));
  }
  savePromotions(promotions: any[]) {
    return firstValueFrom(this.http.post<any>('/api/promotion/save-all', promotions));
  }
  savePromotion(promotion: any) {
    return firstValueFrom(this.http.post<any>('/api/promotion/save', promotion));
  }
  deletePromotion(promotionId: string) {
    return firstValueFrom(this.http.delete<any>(`/api/promotion/delete/${promotionId}`));
  }
  setPromotionIndex(indexes: { [id: string]: number; }) {
    return firstValueFrom(this.http.post(`/api/promotion/index`, indexes));
  }
}

export type PromotionSearchResult = { List: any[]; Total: number; };